import { Search, Filter, X } from 'lucide-react';
import { FormSelect } from '../ui/FormControls';
import Button from '../ui/Button';
import type { AssistantCronFilters } from '../../types/assistantCron';
import type { Assistant } from '../../types/assistant';

interface AssistantCronFiltersProps {
  filters: AssistantCronFilters;
  assistants: Assistant[];
  onChange: (filters: AssistantCronFilters) => void;
  onClear: () => void;
}

function AssistantCronFiltersBar({ filters, assistants, onChange, onClear }: AssistantCronFiltersProps) {
  const hasActiveFilters =
    filters.assistant_id !== undefined ||
    filters.enabled !== undefined ||
    filters.name !== undefined ||
    filters.last_status !== undefined;

  return (
    <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-end sm:gap-4">
      <div className="flex-1">
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Assistente
        </label>
        <FormSelect
          value={filters.assistant_id?.toString() || ''}
          onChange={e =>
            onChange({
              ...filters,
              assistant_id: e.target.value ? Number(e.target.value) : undefined,
            })
          }
        >
          <option value="">Todos</option>
          {assistants.map(assistant => (
            <option key={assistant.id} value={assistant.id}>
              {assistant.name}
            </option>
          ))}
        </FormSelect>
      </div>

      <div className="sm:w-40">
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Status
        </label>
        <FormSelect
          value={filters.enabled === undefined ? '' : filters.enabled ? 'true' : 'false'}
          onChange={e => {
            const value = e.target.value;
            onChange({
              ...filters,
              enabled: value === '' ? undefined : value === 'true',
            });
          }}
        >
          <option value="">Todos</option>
          <option value="true">Ativo</option>
          <option value="false">Inativo</option>
        </FormSelect>
      </div>

      <div className="sm:w-48">
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Último Status
        </label>
        <FormSelect
          value={filters.last_status || ''}
          onChange={e =>
            onChange({
              ...filters,
              last_status: e.target.value || undefined,
            })
          }
        >
          <option value="">Todos</option>
          <option value="success">Sucesso</option>
          <option value="failed">Falhou</option>
          <option value="running">Executando</option>
        </FormSelect>
      </div>

      <div className="flex-1">
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Buscar por nome
        </label>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
          <input
            type="text"
            value={filters.name || ''}
            onChange={e => onChange({ ...filters, name: e.target.value || undefined })}
            placeholder="Buscar..."
            className="block w-full pl-9 pr-3 py-2 border border-gray-300 rounded-md text-sm focus:border-primary-500 focus:ring-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200"
          />
        </div>
      </div>

      {hasActiveFilters && (
        <Button variant="secondary" onClick={onClear} className="sm:mb-0.5">
          <X className="h-4 w-4 mr-1" />
          Limpar
        </Button>
      )}
    </div>
  );
}

export default AssistantCronFiltersBar;
